(function($){

  // -------------------------
  // Thumb window helpers (shared)
  // -------------------------
  var VISIBLE = 6;

  function ensureTrack($thumbs){
    if (!$thumbs.children('.thumb-track').length) {
      $thumbs.wrapInner('<div class="thumb-track"></div>');
    }
    return $thumbs.children('.thumb-track');
  }
  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }
  function calcOffsetPx($track, startIndex){
    var $children = $track.children('.thumb');
    if (!$children.length) return 0;
    var firstRect = $children.eq(0)[0].getBoundingClientRect();
    var startRect = $children.eq(startIndex)[0].getBoundingClientRect();
    return -(startRect.left - firstRect.left);
  }
  function getStart($gallery){ return Number($gallery.data('thumbStart')) || 0; }
  function setStart($gallery, s){ $gallery.data('thumbStart', s); }

  function applyWindow($gallery, startIndex){
    var $thumbs = $gallery.find('.thumbs');
    var $track  = ensureTrack($thumbs);
    var $items  = $track.children('.thumb');
    var maxStart = Math.max(0, $items.length - VISIBLE);
    var s = clamp(startIndex, 0, maxStart);
    var tx = calcOffsetPx($track, s);
    $track.css('transform', 'translateX(' + tx + 'px)');
    setStart($gallery, s);
  }

  function ensureIndexVisible($gallery, index){
    var $thumbs = $gallery.find('.thumbs');
    var $track  = ensureTrack($thumbs);
    var total   = $track.children('.thumb').length;
    if (total <= VISIBLE) return;

    var s = getStart($gallery);
    var leftEdge  = s;
    var rightEdge = s + VISIBLE - 1;

    if (index > rightEdge) {
      s = index - (VISIBLE - 1);
      applyWindow($gallery, s);
    } else if (index < leftEdge) {
      s = index;
      applyWindow($gallery, s);
    }
  }

  // -------------------------
  // Main gallery + integration
  // -------------------------
  (function($){
    const TRANSITION_MS = 300;

    function ensureSlidesTrack($gallery){
      const $slidesWrap = $gallery.find('.slides').first();
      if (!$slidesWrap.length) return null;

      let $track = $slidesWrap.children('.slides-track');
      if (!$track.length){
        $slidesWrap.addClass('is-track');

        $track = $('<div class="slides-track"></div>');
        $slidesWrap.children(':not(.slides-track)').each(function(){
          const $node = $(this);
          if ($node[0].nodeType !== 1) return;
          const $slide = $('<div class="slide"></div>');
          $node.appendTo($slide);
          $track.append($slide);
        });

        $slidesWrap.empty().append($track);
      }
      const $items = $track.children('.slide');
      return { $wrap: $slidesWrap, $track, $items };
    }

    function setTransform($el, index, withAnim){
      $el.css('transition', withAnim ? `transform ${TRANSITION_MS}ms ease` : 'none')
         .css('transform', `translateX(-${index * 100}%)`);
    }

    $(document).ready(function () {
      const galleryInstances = [];

      $('.bundle_gallery').each(function () {
        const $gallery    = $(this);
        const $bullets    = $gallery.find('.bullets');
        const $thumbsWrap = $gallery.find('.thumbs');

        ensureTrack($thumbsWrap);

        const built = ensureSlidesTrack($gallery);
        if (!built) return;
        const { $wrap, $track } = built;

        // Snapshot ALL slides and thumbs with their variants before any filtering.
        // Non-matching elements are detached from the DOM during filtering rather
        // than hidden, so the transform-based slider always counts correctly.
        const allSlides = [];
        $track.children('.slide').each(function(){
          const variant = $(this).find('[data-variant]').attr('data-variant') || '';
          allSlides.push({ el: this, variant });
        });

        const allThumbs = [];
        $thumbsWrap.find('.thumb').each(function(){
          const variant = $(this).attr('data-variant') || '';
          allThumbs.push({ el: this, variant });
        });

        const hasThumbs = allThumbs.length > 0;
        let currentIndex = 0;

        // showSlide always reads the live count from the track so it
        // works correctly after filtering rebuilds the set.
        function showSlide(index, animate){
          const count = $track.children('.slide').length;
          if (!count) return;
          if (animate === undefined) animate = true;

          if (index < 0) index = (index + count) % count;
          if (index >= count) index = index % count;

          setTransform($track, index, animate);

          const $thumbTrack = ensureTrack($thumbsWrap);
          if (hasThumbs && $thumbTrack.children('.thumb').length){
            $thumbTrack.children('.thumb').removeClass('active').eq(index).addClass('active');
            ensureIndexVisible($gallery, index);
          } else if ($bullets.length){
            $gallery.find('.bullet').removeClass('active').eq(index).addClass('active');
          }

          currentIndex = index;
          $('.bundle_gallery.desktop').trigger('sticky:recalc');
        }

        // filterByVariant rebuilds the slide track and thumb track with only
        // the elements matching the given variant. Pass null to show everything.
        // Empty-variant elements are treated as universal and always shown.
        function filterByVariant(variant){
          // Rebuild slides track
          $track.empty();
          allSlides.forEach(function(s){
            if (!variant || s.variant === '' || s.variant === variant){
              $track.append(s.el);
            }
          });

          // Rebuild thumbs track (sequential data-index for the visible set)
          if (hasThumbs){
            const $thumbTrack = ensureTrack($thumbsWrap);
            $thumbTrack.empty();
            let thumbIdx = 0;
            allThumbs.forEach(function(t){
              if (!variant || t.variant === '' || t.variant === variant){
                $(t.el).attr('data-index', thumbIdx++).removeClass('active');
                $thumbTrack.append(t.el);
              }
            });
            $thumbTrack.children('.thumb').first().addClass('active');
          }

          // Reset slider position and thumb window
          currentIndex = 0;
          setTransform($track, 0, false);
          setStart($gallery, 0);
          applyWindow($gallery, 0);

          // Rebuild bullets to match the new slide count
          if ($bullets.length && !hasThumbs){
            const count = $track.children('.slide').length;
            $bullets.empty();
            for (let i = 0; i < count; i++){
              const $b = $('<span class="bullet"></span>');
              if (i === 0) $b.addClass('active');
              $b.on('click', function(){ showSlide(i); });
              $bullets.append($b);
            }
          }
        }

        // Use event delegation for thumb clicks so handlers survive
        // track rebuilds during variant switches.
        $thumbsWrap
          .off('click.thumbnav click.thumbwin')
          .on('click.thumbnav', 'button.thumb', function(){
            const idx = parseInt($(this).attr('data-index'), 10);
            if (!isNaN(idx)) showSlide(idx);
          })
          .on('click.thumbwin', 'button.thumb', function(){
            const $btn   = $(this);
            const $t     = ensureTrack($thumbsWrap);
            const $itemsT = $t.children('.thumb');
            const totalT  = $itemsT.length;
            if (totalT <= VISIBLE) return;

            let s = getStart($gallery);
            const idx = $itemsT.index($btn);
            const leftEdge  = s;
            const rightEdge = s + VISIBLE - 1;

            if (idx >= rightEdge - 1 && (s + VISIBLE) < totalT) {
              s += 1;
              applyWindow($gallery, s);
            } else if (idx <= leftEdge + 1 && s > 0) {
              s -= 1;
              applyWindow($gallery, s);
            }
          });

        // Arrows
        const $prev = $('<button class="arrow prev" aria-label="Previous slide"><span class="gg-chevron-left"></span></button>');
        const $next = $('<button class="arrow next" aria-label="Next slide"><span class="gg-chevron-right"></span></button>');
        const $arrowHost = $gallery.find('.arrows').length ? $gallery.find('.arrows') : $gallery;
        $arrowHost.append($prev, $next);

        $prev.on('click', function(){ showSlide(currentIndex - 1); });
        $next.on('click', function(){ showSlide(currentIndex + 1); });

        // Swipe
        let startX = 0;
        $wrap.on('touchstart', function(e){ startX = e.originalEvent.touches[0].clientX; });
        $wrap.on('touchend',   function(e){
          const endX = e.originalEvent.changedTouches[0].clientX;
          if (endX < startX - 30)      showSlide(currentIndex + 1);
          else if (endX > startX + 30) showSlide(currentIndex - 1);
        });

        // Keep current slide and thumb window aligned on resize
        let pending = false;
        $(window).off('resize.thumbsync').on('resize.thumbsync', function(){
          if (pending) return;
          pending = true;
          requestAnimationFrame(function(){
            pending = false;
            setTransform($track, currentIndex, false);
            applyWindow($gallery, getStart($gallery));
          });
        });

        $gallery.data('showSlide', showSlide);
        $gallery.data('filterByVariant', filterByVariant);
        galleryInstances.push($gallery);
      });

      // -------------------------
      // Variant / swatch buttons
      // -------------------------
      const $swatches = $('.product_swatches button');
      const $swatchWrappers = $('.product_swatches_wrapper');

      function syncSwatches(variant, variantTitle){
        // selected state on both desktop + mobile buttons
        $swatches.removeClass('selected');

        const $matchingSwatches = $swatches.filter(function(){
          return $(this).attr('data-variant') === variant;
        });

        $matchingSwatches.addClass('selected');

        // fallback title if one was not passed in
        if (!variantTitle) {
          variantTitle = $matchingSwatches.first().attr('data-variant-title') || '';
        }

        // update BOTH h3 spans
        $swatchWrappers.find('h3 span').text(variantTitle);

        // filter ALL galleries
        galleryInstances.forEach(function($g){
          const fn = $g.data('filterByVariant');
          if (fn) fn(variant);
        });
      }

      if ($swatches.length){
        const $initialSwatch = $swatches.filter('.selected').first().length
          ? $swatches.filter('.selected').first()
          : $swatches.first();

        const initialVariant = $initialSwatch.attr('data-variant');
        const initialTitle = $initialSwatch.attr('data-variant-title');

        // Apply initial selected state/title/filter on load
        if (galleryInstances.length){
          syncSwatches(initialVariant, initialTitle);
        } else {
          // Still sync the desktop/mobile swatches + span even if no gallery exists
          $swatches.removeClass('selected');
          $swatches.filter(function(){
            return $(this).attr('data-variant') === initialVariant;
          }).addClass('selected');

          $swatchWrappers.find('h3 span').text(initialTitle || '');
        }

        $swatches.off('click.variantSwatches').on('click.variantSwatches', function(){
          const $btn = $(this);
          const variant = $btn.attr('data-variant');
          const variantTitle = $btn.attr('data-variant-title');

          syncSwatches(variant, variantTitle);
        });

      } else if (galleryInstances.length){
        // No swatches present — show all slides unfiltered
        galleryInstances.forEach(function($g){
          const fn = $g.data('filterByVariant');
          if (fn) fn(null);
        });
      }

    });
  })(jQuery);

})(jQuery);



/* Without Add Button

$(function () {
  var $nextStepLink = $('.next_step a');
  var baseHref = $nextStepLink.attr('href');
  var bundleManuallySelected = $('.bundle_selection button.selected').length > 0;
  function formatMoney(amount, symbol) {
    var rounded = Math.round(amount * 100) / 100;
    return symbol + (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2));
  }

  function updatePriceLabel() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    var $priceSpan = $('.next_step a span:not(.checkout-label)');
    var symbol = $('.currency_symbol').val() || '$';
    var originalPerItem = parseInt($('.original_price').val(), 10) / 100;
    var $buttons = $('.bundle_selection button');
    var selectedIndex = $buttons.index($buttons.filter('.selected'));
    var lastIndex = $buttons.length - 1;
    if (total >= 2) {
      var usePrice2 = total >= 3 || selectedIndex === lastIndex;
      var perItem = parseFloat($(usePrice2 ? '.discounted_price_2' : '.discounted_price_1').val().replace(/[^0-9.]/g, ''));
      $priceSpan.html('<s>' + formatMoney(originalPerItem * total, symbol) + '</s> ' + formatMoney(perItem * total, symbol));
    } else {
      $priceSpan.text(formatMoney(originalPerItem * total || originalPerItem, symbol));
    }
  }

  function getSelectedVariants() {
    var selected = [];
    $('.product_selection .quantity_selector').each(function () {
      var qty = parseInt($(this).find('.quant').val(), 10) || 0;
      if (qty > 0) {
        var id = $(this).data('id');
        selected.push(id + ':' + qty);
      }
    });
    return selected;
  }

  function getRequiredQty() {
    var index = $('.bundle_selection button').index($('.bundle_selection button.selected'));
    return index + 1; // 1st=1, 2nd=2, 3rd=3
  }

  function updateNextStepHref() {
    var selected = getSelectedVariants();
    var total = selected.reduce(function (sum, item) {
      return sum + parseInt(item.split(':')[1], 10);
    }, 0);
    var meetsRequirement = total >= getRequiredQty();
    if (meetsRequirement) {
      $nextStepLink.attr('href', baseHref + ',' + selected.join(','));
      $nextStepLink.removeClass('disabled');
    } else {
      $nextStepLink.removeAttr('href');
      $nextStepLink.addClass('disabled');
    }
  }

  function updateBundleButtonStates(total) {
    var $buttons = $('.bundle_selection button');
    var lastIndex = $buttons.length - 1;
    $buttons.each(function (index) {
      if (index === lastIndex) return; // last button is never disabled
      var impliedQty = index + 1;
      $(this).toggleClass('disabled', total > impliedQty);
    });
  }

  function syncBundleSelection(total) {
    var $buttons = $('.bundle_selection button');
    var currentIndex = $buttons.index($buttons.filter('.selected'));
    var targetIndex = currentIndex;
    if (total >= 3 && currentIndex < 2) targetIndex = 2;
    else if (total >= 2 && currentIndex < 1) targetIndex = 1;
    if (targetIndex !== currentIndex) {
      $buttons.removeClass('selected');
      $buttons.eq(targetIndex).addClass('selected');
      bundleManuallySelected = false;
    }
  }

  function updateWantInput() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    $('input[name="want"]').val(total);
  }

  function updateCheckoutLabel() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    var required = getRequiredQty();
    var remaining = required - total;
    var label = remaining > 0 ? 'Add ' + remaining + (remaining === 1 ? ' Smiley' : ' Smileys') : 'Checkout';
    $('.checkout-label').text(label);
  }

  function updateDecButtonStates() {
    $('.product_selection .quantity_selector').each(function () {
      var val = parseInt($(this).find('.quant').val(), 10) || 0;
      $(this).find('.dec').toggleClass('disabled', val === 0);
    });
  }

  // Set initial state on load
  updateDecButtonStates();
  updateCheckoutLabel();
  updatePriceLabel();

  $(document).on('click', '.bundle_selection button', function () {
    if ($(this).hasClass('disabled')) return;
    $('.bundle_selection button').removeClass('selected');
    $(this).addClass('selected');
    bundleManuallySelected = true;
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });

  $(document).on('click', '.product_selection .quantity_selector .inc', function () {
    var $input = $(this).siblings('.quant');
    var val = parseInt($input.val(), 10) || 0;
    $input.val(val + 1);
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () { total += parseInt($(this).val(), 10) || 0; });
    syncBundleSelection(total);
    updateBundleButtonStates(total);
    updateDecButtonStates();
    updateWantInput();
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });

  $(document).on('click', '.product_selection .quantity_selector .dec', function () {
    var $input = $(this).siblings('.quant');
    var val = parseInt($input.val(), 10) || 0;
    if (val > 0) $input.val(val - 1);
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () { total += parseInt($(this).val(), 10) || 0; });
    updateBundleButtonStates(total);
    updateDecButtonStates();
    updateWantInput();
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });
});

*/

$(function () {
  var $nextStepLink = $('.next_step a');
  var baseHref = $nextStepLink.attr('href');
  var bundleManuallySelected = $('.bundle_selection button.selected').length > 0;
  function formatMoney(amount, symbol) {
    var rounded = Math.round(amount * 100) / 100;
    return symbol + (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2));
  }

  function updatePriceLabel() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    var $priceSpan = $('.next_step a span:not(.checkout-label)');
    var symbol = $('.currency_symbol').val() || '$';
    var originalPerItem = parseInt($('.original_price').val(), 10) / 100;
    var $buttons = $('.bundle_selection button');
    var selectedIndex = $buttons.index($buttons.filter('.selected'));
    var lastIndex = $buttons.length - 1;
    if (total >= 2) {
      var usePrice2 = total >= 3 || selectedIndex === lastIndex;
      var perItem = parseFloat($(usePrice2 ? '.discounted_price_2' : '.discounted_price_1').val().replace(/[^0-9.]/g, ''));
      $priceSpan.html('<s>' + formatMoney(originalPerItem * total, symbol) + '</s> ' + formatMoney(perItem * total, symbol));
    } else {
      $priceSpan.text(formatMoney(originalPerItem * total || originalPerItem, symbol));
    }
  }

  function getSelectedVariants() {
    var selected = [];
    $('.product_selection .quantity_selector').each(function () {
      var qty = parseInt($(this).find('.quant').val(), 10) || 0;
      if (qty > 0) {
        var id = $(this).data('id');
        selected.push(id + ':' + qty);
      }
    });
    return selected;
  }

  function getRequiredQty() {
    var index = $('.bundle_selection button').index($('.bundle_selection button.selected'));
    return index + 1; // 1st=1, 2nd=2, 3rd=3
  }

  function updateNextStepHref() {
    var selected = getSelectedVariants();
    var total = selected.reduce(function (sum, item) {
      return sum + parseInt(item.split(':')[1], 10);
    }, 0);
    var meetsRequirement = total >= getRequiredQty();
    if (meetsRequirement) {
      $nextStepLink.attr('href', baseHref + ',' + selected.join(','));
      $nextStepLink.removeClass('disabled');
    } else {
      $nextStepLink.removeAttr('href');
      $nextStepLink.addClass('disabled');
    }
  }

  function updateBundleButtonStates(total) {
    var $buttons = $('.bundle_selection button');
    var lastIndex = $buttons.length - 1;
    $buttons.each(function (index) {
      if (index === lastIndex) return; // last button is never disabled
      var impliedQty = index + 1;
      $(this).toggleClass('disabled', total > impliedQty);
    });
  }

  function syncBundleSelection(total) {
    var $buttons = $('.bundle_selection button');
    var currentIndex = $buttons.index($buttons.filter('.selected'));
    var targetIndex = currentIndex;
    if (total >= 3 && currentIndex < 2) targetIndex = 2;
    else if (total >= 2 && currentIndex < 1) targetIndex = 1;
    if (targetIndex !== currentIndex) {
      $buttons.removeClass('selected');
      $buttons.eq(targetIndex).addClass('selected');
      bundleManuallySelected = false;
    }
  }

  function updateWantInput() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    $('input[name="want"]').val(total);
  }

  function updateCheckoutLabel() {
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    var required = getRequiredQty();
    var remaining = required - total;
    var label = remaining > 0 ? 'Add ' + remaining + (remaining === 1 ? ' Smiley' : ' Smileys') : 'Checkout';
    $('.checkout-label').text(label);
  }

  function updateDecButtonStates() {
    $('.product_selection .quantity_selector').each(function () {
      var val = parseInt($(this).find('.quant').val(), 10) || 0;
      $(this).find('.dec').toggleClass('disabled', val === 0);
    });
  }

  // Set initial state on load
  updateDecButtonStates();
  updateCheckoutLabel();
  updatePriceLabel();

  $(document).on('click', '.bundle_selection button', function () {
    if ($(this).hasClass('disabled')) return;
    $('.bundle_selection button').removeClass('selected');
    $(this).addClass('selected');
    bundleManuallySelected = true;
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });

  $(document).on('click', '.product_selection .add_btn', function () {
    var $wrapper = $(this).closest('div');
    var $selector = $wrapper.find('.quantity_selector');
    var $input = $selector.find('.quant');
    $input.val(1);
    $(this).hide();
    $selector.show();
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () { total += parseInt($(this).val(), 10) || 0; });
    syncBundleSelection(total);
    updateBundleButtonStates(total);
    updateDecButtonStates();
    updateWantInput();
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });

  $(document).on('click', '.product_selection .quantity_selector .inc', function () {
    var $input = $(this).siblings('.quant');
    var val = parseInt($input.val(), 10) || 0;
    $input.val(val + 1);
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () { total += parseInt($(this).val(), 10) || 0; });
    syncBundleSelection(total);
    updateBundleButtonStates(total);
    updateDecButtonStates();
    updateWantInput();
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });

  $(document).on('click', '.product_selection .quantity_selector .dec', function () {
    var $input = $(this).siblings('.quant');
    var val = parseInt($input.val(), 10) || 0;
    if (val > 0) $input.val(val - 1);
    if (val - 1 <= 0) {
      var $selector = $(this).closest('.quantity_selector');
      $selector.hide();
      $selector.siblings('.add_btn').show();
    }
    var total = 0;
    $('.product_selection .quantity_selector .quant').each(function () { total += parseInt($(this).val(), 10) || 0; });
    updateBundleButtonStates(total);
    updateDecButtonStates();
    updateWantInput();
    updateCheckoutLabel();
    updatePriceLabel();
    updateNextStepHref();
  });
});



// Handle tabs

jQuery(function($) {
  $('.upper_tabs').on('click', 'div h3', function() {
    var $h3 = $(this);
    var $content = $h3.next('p, ul');

    if (!$content.length) return;

    if ($content.is(':visible')) {
      $content.slideUp(200);
      $h3.removeClass('tab_active');
    } else {
      $content.slideDown(200);
      $h3.addClass('tab_active');
    }
  });
});